import template from './print-design.template.html';
import {PrintDesignController} from "./print-design.controller";

export class PrintDesignService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;

    }

    open() {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: PrintDesignController,
            controllerAs: '$ctrl'
        });

        modalInstance.result.then(() => {

        }, () => {
            this.$log.info('Modal dismissed at: ' + new Date());
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/print-design/print-design.service.js